import useSWR, { mutate } from 'swr';
import { useCallback } from 'react';
import type { MatterAccess } from '@/types/base';
import { backendClient } from '@/lib/api-client';

const fetcher = async (url: string) => {
  const response = await backendClient.get(url);
  return response.data;
};

// Stable empty-array reference. Returning a fresh `[]` on every render (e.g.
// `data ?? []`) feeds an unstable `data` prop to `useReactTable`, which retriggers
// its row-model memos + `autoResetPageIndex` every render and causes an infinite
// re-render loop (freeze) while SWR is loading.
const EMPTY_MATTERS: MatterAccess[] = [];

const useMatters = (viewArchived: boolean) => {
  const url = viewArchived ? '/matter/get_inactive' : '/matter/get_active';

  const { data, error, isLoading, isValidating } = useSWR<MatterAccess[]>(
    url,
    fetcher
  );

  const mutateMatters = useCallback(() => mutate(url), [url]);

  return {
    isLoading,
    isValidating,
    isError: error,
    matters: data ?? EMPTY_MATTERS,
    mutateMatters,
  };
};

export default useMatters;
